import React, { FC, useCallback, useRef, useState } from 'react'

import { useVideoMeta } from '../../hooks/useVideoMeta'
import { formatTime } from '../../utils/TimeUtils'

import * as SC from './styled'

export type VideoProps = {
  className?: string
  watchTranscriptText?: string
  video?: {
    poster?: string
    src?: string
    transcription?: string
  }
  seeDuration?: boolean
}

const Video: FC<VideoProps> = (props) => {
  const { className, watchTranscriptText, video, seeDuration = true } = props
  const [transcriptOpen, setTranscriptOpen] = useState(false)
  const [videoPlaying, setIsVideoPlaying] = useState(false)
  const $videoElement = useRef<HTMLVideoElement>(null)

  const toggleTranscript = useCallback(() => {
    setTranscriptOpen((prevValue: boolean) => !prevValue)
  }, [setTranscriptOpen])

  const onPlayCallback = useCallback(() => {
    setIsVideoPlaying(true)
  }, [setIsVideoPlaying])

  const onPauseCallback = useCallback(() => {
    setIsVideoPlaying(false)
  }, [setIsVideoPlaying])

  const onEndedCallback = useCallback(() => {
    setIsVideoPlaying(false)
    if (typeof $videoElement?.current !== 'undefined') {
      $videoElement?.current?.load()
    }
  }, [setIsVideoPlaying, $videoElement])

  const { duration } = useVideoMeta(video?.src ?? '')

  return (
    <SC.Container className={className}>
      <SC.Video>
        {!videoPlaying && duration && seeDuration && (
          <SC.VideoDuration>{formatTime(duration)}</SC.VideoDuration>
        )}
        <SC.VideoElement
          ref={$videoElement}
          onPlay={onPlayCallback}
          onPause={onPauseCallback}
          onEnded={onEndedCallback}
          src={video?.src}
          poster={video?.poster}
          controls
        />
      </SC.Video>
      {watchTranscriptText && video?.transcription && (
        <>
          <SC.ToggleTranscript onClickHandler={toggleTranscript}>
            {watchTranscriptText}
          </SC.ToggleTranscript>
          {transcriptOpen && (
            <SC.Transcript>{video?.transcription}</SC.Transcript>
          )}
        </>
      )}
    </SC.Container>
  )
}

export default Video
